import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginComponent from "../views/login.vue"
import SecureComponent from "../views/Home.vue"
import VideoComponent from "../views/video.vue"
import VideoNoAuthComponent from "../views/video-no-auth.vue"
import PersonalComponent from "../views/dashboard.vue"
import RegistrationComponent from "../views/registration.vue"
import VueSession from 'vue-session'

Vue.use(VueSession);
Vue.use(VueRouter)

//   const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   }
// ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        redirect: {
            name: "login"
        }
    },
    {
        path: "/login",
        name: "login",
        component: LoginComponent
    },
    {
        path: "/registration",
        name: "registration",
        component: RegistrationComponent
    },
    {
        path: "/Home",
        name: "Home",
        component: SecureComponent
    }, 
    {
        path: "/video/:id",
        name: "video",
        component: VideoComponent, 
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: PersonalComponent
    },
    {
        path: "/video-no-auth/:id",
        name: "video-no-auth",
        component: VideoNoAuthComponent, 
    },
]
})

export default router
